export default __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/zonademand_UB_tablet.e17711e8.png";